export default "__VITE_ASSET__CxQWHshc__";